module.exports = __webpack_public_path__ + "images/icon-ios-app.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/icon-ios-app.png
// module id = 842
// module chunks = 106